export default "__VITE_ASSET__D87QqVYB__"